import { makeStyles } from "@material-ui/core";
import { BorderRight } from "@material-ui/icons";

export const useStyles = makeStyles((theme) => ({
  gridStyles: {
    font: "Inter, Roboto, Helvetica, Arial, sans-serif",
    fontSize: "14px",
    fontweight: 400,
  },
  tableWrapper: {
    border: "none",
    color: "#000000DE",
    fontSize: "14px",
    fontWeight: 400,
    maxWidth: theme.spacing(200),
    "& .MuiDataGrid-cell": {
      padding: "0 0 0 10px !important",
    },
    "& .MuiDataGrid-cell:first-child, & .MuiDataGrid-cell:nth-child(2)": {
      paddingRight: "10px !important",
    },
  },
  smallFooter: {
    height: theme.spacing(5.5),
  }
}));
